"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const common_1 = require("@Const/common");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const clsx_1 = __importDefault(require("clsx"));
class CheckBox extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "isChecked", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.checked || false
        });
        Object.defineProperty(this, "isSomeChecked", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "allCheckedToggle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.isSomeChecked) {
                    this.isSomeChecked = false;
                    this.isChecked = true;
                    return;
                }
                this.isChecked = !this.isChecked;
                this.props.onClick(this.isChecked, this.props.id);
            }
        });
        Object.defineProperty(this, "setCheckedState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.isChecked = value;
            }
        });
        (0, mobx_1.makeObservable)(this, {
            isChecked: mobx_1.observable,
            isSomeChecked: mobx_1.observable,
            allCheckedToggle: mobx_1.action,
            setCheckedState: mobx_1.action,
        });
    }
    componentDidUpdate() {
        if (typeof this.props.checked === 'boolean' && this.props.checked !== this.isChecked) {
            this.setCheckedState(this.props.checked);
        }
    }
    render() {
        const { size = 'normal', mainColor, text, labelInfo, disabled, readonly, errorMessage, required, children, id, className, rounded, } = this.props;
        const classNames = (0, clsx_1.default)('checkbox-component', mainColor ? 'main-color-set' : 'second-color-set', `checkbox-${size}`, this.isChecked && 'checked', disabled && 'disabled', readonly && 'readonly', rounded && 'rounded', className);
        return (react_1.default.createElement("div", { className: classNames, role: 'checkbox', "aria-checked": this.isChecked, "data-testid": 'checkbox-component-' + id },
            react_1.default.createElement("div", { className: "checkbox-wrapper", onClick: this.allCheckedToggle, "data-testid": 'checkbox-wrapper-' + id }, this.isChecked ? react_1.default.createElement("img", { src: common_1.ICONS.done, className: "checkbox-icon", alt: "checkbox" }) : null),
            react_1.default.createElement("span", { className: "checkbox-description" },
                react_1.default.createElement("span", { onClick: this.allCheckedToggle }, text),
                react_1.default.createElement("span", null, children)),
            labelInfo && react_1.default.createElement(CustomToolTip_1.default, { type: 'i', info: labelInfo }),
            errorMessage ? (react_1.default.createElement("span", { className: "error-text" }, errorMessage)) : (required && react_1.default.createElement("span", { className: 'required' }, "Required"))));
    }
}
exports.default = (0, mobx_react_1.observer)(CheckBox);
